import './ExpandableBlock.css';
import { useEffect, useRef, useState } from 'react';
import { caret_down, caret_up, Icon } from '../Icon/Icon';
import { useTranslation } from '../../i18n/i18n';
import { UiContainer } from '../../state/ui';

type ExpandableBlockProps = {
	item: JSX.Element;
	maxHeight: number;
	onUpdate?: Function;
};

export const ExpandableBlock = ({ item, maxHeight, onUpdate }: ExpandableBlockProps) => {
	const [expandability, setExpandability] = useState(true);
	const [isExpanded, setIsExpanded] = useState(false);
	const [canExpand, setCanExpand] = useState(false);
	const elementRef = useRef<HTMLDivElement>(null);
	const t = useTranslation().generic;
	const ui = UiContainer.useContainer();

	useEffect(() => {
		if (elementRef.current) {
			if (maxHeight >= elementRef.current.offsetHeight) {
				setExpandability(false);
				ui.setHasExpandableDescription(false);
				return;
			}

			setCanExpand(elementRef.current.offsetHeight > maxHeight);
			setIsExpanded(false);
			ui.setHasExpandableDescription(true);
		}
	}, []);

	return (
		<expandable-block class={`${isExpanded ? 'expanded' : ''} ${canExpand ? 'can-expand' : ''}`}>
			<div ref={elementRef}>{item}</div>
			{expandability && canExpand && (
				<>
					<div className="expander-banner-gradient" />
					<div
						className="expander-banner"
						onClick={() => {
							setIsExpanded(!isExpanded);
							if (onUpdate) onUpdate(!isExpanded);
						}}
					>
						<div className="expander-text">
							<span className="expander-text-inner">{isExpanded ? t.readLess : t.readMore}</span>
						</div>
						<div className="expander-icon">
							<Icon shape={isExpanded ? caret_up : caret_down} />
						</div>
					</div>
				</>
			)}
		</expandable-block>
	);
};
